export default __webpack_public_path__ + "static/media/0x42d61d766b85431666b39b89c43011f24451bff6.9fdeda75.webp";